import { Activity } from 'lucide-react'
import type { ModuleDefinition } from '../types'
import { lazyPage } from '@/lib/lazyPage'

const FeedPage = lazyPage(() => import('@/pages/Feed'), 'FeedPage')
const ContentDetailsPage = lazyPage(() => import('@/pages/ContentDetails'), 'ContentDetailsPage')

export const feedModule: ModuleDefinition = {
  menuCounters: true,
  key: 'feed',
  icon: Activity,
  iconName: 'activity',
  namespaces: ['feed'],
  ready: true,
  ListPage: FeedPage,
  /* An article posted in a feed opens on its own page, like in a content space */
  renderDetail: ({ spaceData }) => <ContentDetailsPage spaceId={spaceData?.id} />,
  workflow: { spaceActions: ['content.post.create'] }
}
